import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { WhatsAppFab } from "./components/WhatsApp";
import Home from "./pages/Home";
import TentangPage from "./pages/TentangPage";
import ArmadaKategoriPage from "./pages/ArmadaKategoriPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import "./App.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-navy p-8 text-center">
          <div>
            <p className="font-display text-3xl font-bold">Terjadi kesalahan</p>
            <p className="mt-2 text-zinc-400">Muat ulang halaman untuk melanjutkan.</p>
            <button
              data-testid="error-reload-button"
              className="mt-6 rounded-full bg-gold text-white font-semibold px-6 py-3"
              onClick={() => window.location.reload()}
            >
              Muat Ulang
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 400);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <SmoothScroll />
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-ink text-navy p-8 text-center">
      <div>
        <p className="eyebrow">404</p>
        <p className="mt-3 font-display text-4xl font-extrabold uppercase">Halaman tidak ditemukan</p>
        <Link
          data-testid="notfound-home-link"
          to="/"
          className="mt-8 inline-flex rounded-full bg-gold text-white font-semibold px-7 py-3 hover:bg-gold-deep transition-colors"
        >
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tentang" element={<TentangPage />} />
            <Route path="/armada/:key" element={<ArmadaKategoriPage />} />
            <Route path="/galeri" element={<GalleryPage />} />
            <Route path="/kontak" element={<ContactPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="bottom-right" theme="light" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
